import { Component } from '@angular/core';

@Component({
  selector: 'app-department-sales-summary',
  standalone: false,
  
  templateUrl: './department-sales-summary.component.html',
  styles: ``
})
export class DepartmentSalesSummaryComponent {

}
